import React from "react";

import { Card } from "@/components/ui/card";
import { cn, formatNumber } from "@/lib/utils";

export interface StatsCardProps {
    value: number;
    title: string;
    className?: string;
    subtitle?: string;
    icon?: React.ReactNode;
}

const StatsCard: React.FC<StatsCardProps> = ({ value, title, className, subtitle, icon }) => {
    return (
        <Card className={cn("border-none bg-sky-400 text-white p-4", className)}>
            <div className="flex items-end justify-between gap-4">
                <div className="subpixel-antialiased">
                    <h1 className="text-6xl font-bold">{formatNumber(value)}</h1>
                    <h5 className="max-w-48 truncate font-semibold ">{title}</h5>
                    <h6 className="max-w-48 truncate text-xs font-semibold ">{subtitle ?? ""}</h6>
                </div>
                {icon ?? ""}
            </div>
        </Card>
    );
};

export default StatsCard;
